import { TextField } from "@mui/material";
import { Box } from "@mui/system";
import { CButton, CP } from "../components";

export default function ContactForm() {
    const handleSubmit = (event) => {
        event.preventDefault();
    }

    return <>
        <Box sx={{ width: '100%' }}>
            <iframe 
                src="https://docs.google.com/forms/d/e/1FAIpQLSdfhPAArbYTEOvai5ilkAIVCHsRSwCAHHeGcxQgNK6FcsUwlQ/viewform?embedded=true" 
                style={{
                    width: '100%',
                    height: '1080px',
                    border: 'none',
                    margin: 0,
                    padding: 0,
                }}
            >
                Loading…
            </iframe>
        </Box>
        
        {/* <h3>İletişim Formu</h3>
        Öneriler, iş birlikleri ve özel mesajlarınız için formu doldurun.
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
                margin="dense"
                autoComplete="given-name"
                name="firstName"
                required
                fullWidth
                id="firstName"
                label="İsim, Soyisim"
            />
            <TextField
                margin="dense"
                required
                fullWidth
                id="email"
                label="Eposta Adresi"
                name="email"
                autoComplete="email"
            />
            <TextField
                margin="dense"
                required
                fullWidth
                multiline
                rows={4}
                name="message"
                label="Mesaj"
                type="text"
                id="message"
                autoComplete="message"
            />
            <CButton
            type="submit">
                Gönder
            </CButton>
        </Box> */}
        

    </>
}